var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_2947",
    "data-name": "Groupe 2947",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.84,
    height: 20.062,
    viewBox: "0 0 16.84 20.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2014",
    "data-name": "Trac\\xE9 2014",
    d: "M-180.557,2719.641a1.51,1.51,0,0,0,1.51-1.51,1.51,1.51,0,0,0-1.51-1.51h-2.461a4.158,4.158,0,0,1-3.25-1.561,4.217,4.217,0,0,1-.815-3.564,4.284,4.284,0,0,1,4.256-3.215h2.27a1.51,1.51,0,0,0,1.51-1.51,1.51,1.51,0,0,0-1.51-1.51h-2.27a7.319,7.319,0,0,0-7.207,5.591,7.223,7.223,0,0,0,1.413,6.1,7.163,7.163,0,0,0,5.6,2.688Z",
    transform: "translate(190.206 -2705.26)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2015",
    "data-name": "Trac\\xE9 2015",
    d: "M-152.417,2736.161a7.163,7.163,0,0,0-5.6-2.688h-2.461a1.51,1.51,0,0,0-1.51,1.51,1.51,1.51,0,0,0,1.51,1.51h2.461a4.157,4.157,0,0,1,3.25,1.561,4.218,4.218,0,0,1,.815,3.564,4.285,4.285,0,0,1-4.256,3.215h-2.27a1.51,1.51,0,0,0-1.51,1.51,1.51,1.51,0,0,0,1.51,1.51h2.27a7.32,7.32,0,0,0,7.207-5.591A7.225,7.225,0,0,0-152.417,2736.161Z",
    transform: "translate(167.672 -2727.792)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIconWhite);
export default __webpack_public_path__ + "static/media/swapIconWhite.950c6a42b2b0f88a82a77747f18ae63d.svg";
export { ForwardRef as ReactComponent };